// utils/injectFontImport.ts
export function injectFontImport(doc: Document, key: string, src: string) {
    const head = doc.head;
    if (!head || !src) return;

    // déjà présent ?
    if (head.querySelector(`[data-branding-font="${CSS.escape(key)}"]`)) return;

    const trimmed = src.trim();

    // Cas <link ...>
    if (trimmed.startsWith("<link")) {
        const wrapper = doc.createElement("div");
        wrapper.innerHTML = trimmed;
        const link = wrapper.querySelector("link");
        if (link) {
            link.setAttribute("data-branding-font", key);
            head.appendChild(link);
        }
        return;
    }

    // Cas CSS (@import, @font-face, etc.)
    const styleEl = doc.createElement("style");
    styleEl.setAttribute("data-branding-font", key);
    styleEl.append(trimmed);
    head.appendChild(styleEl);
}
